module.exports = __webpack_public_path__ + "static/Biometric Verification Service Agreement v6.0-b00dfb9fc93af67cd9cf1a56f7139f51.pdf";